import useInitializeTechnologyAdvancedForm from './useInitializeTechnologyAdvancedForm'

export default useInitializeTechnologyAdvancedForm
